export const GET_MARKETPACKINGS = "GET_MARKETPACKINGS";
export const GET_MARKETPACKING_UPDATE = "GET_MARKETPACKING_UPDATE";
export const COPY_MARKETPACKING = "COPY_MARKETPACKING"